import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import Markdown from 'react-markdown';
import RemarkBreaks from 'remark-breaks';
import {
  HTML_ELEMENTS,
  markdownRootRenderer,
  markdownLinkRenderer,
} from 'Components/utils/markdown/markdown';
import { themes } from './Text.themes';
const MARKDOWN_TEXT = [
  HTML_ELEMENTS.BREAK.type,
  HTML_ELEMENTS.EMPHASIS.type,
  HTML_ELEMENTS.HEADING.type,
  HTML_ELEMENTS.LINK.type,
  HTML_ELEMENTS.LIST.type,
  HTML_ELEMENTS.LIST_ITEM.type,
  HTML_ELEMENTS.PARAGRAPH.type,
  HTML_ELEMENTS.STRONG.type,
  HTML_ELEMENTS.TEXT.type,
];
export type TextProps = {
  className?: string;
  text?: string;
  theme?: keyof typeof themes;
};
export const Text = ({ className, text, theme = 'text-sans-n1', ...props }: TextProps) => {
  if (!text) {
    return null;
  }

  const { thRoot } = themes[theme];
  return (
    <Markdown
      allowedTypes={MARKDOWN_TEXT}
      className={classnames(thRoot, className)}
      plugins={[RemarkBreaks]}
      renderers={{
        root: markdownRootRenderer(props),
        link: markdownLinkRenderer(),
      }}
    >
      {text}
    </Markdown>
  );
};
